var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9620_70830",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#666666"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9620_70830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 23.2692V20.6846C5.5 20.1615 5.63462 19.6808 5.90385 19.2423C6.17308 18.8038 6.53077 18.4692 6.97692 18.2385C7.93077 17.7615 8.9 17.4038 9.88462 17.1654C10.8692 16.9269 11.8692 16.8077 12.8846 16.8077C13.9 16.8077 14.9 16.9269 15.8846 17.1654C16.8692 17.4038 17.8385 17.7615 18.7923 18.2385C19.2385 18.4692 19.5962 18.8038 19.8654 19.2423C20.1346 19.6808 20.2692 20.1615 20.2692 20.6846V23.2692H5.5ZM22.1154 23.2692V20.5C22.1154 19.8231 21.9269 19.1731 21.55 18.55C21.1731 17.9269 20.6385 17.3923 19.9462 16.9462C20.7308 17.0385 21.4692 17.1962 22.1615 17.4192C22.8538 17.6423 23.5 17.9154 24.1 18.2385C24.6538 18.5462 25.0769 18.8885 25.3692 19.2654C25.6615 19.6423 25.8077 20.0538 25.8077 20.5V23.2692H22.1154ZM12.8846 15.8846C11.8692 15.8846 11 15.5231 10.2769 14.8C9.55385 14.0769 9.19231 13.2077 9.19231 12.1923C9.19231 11.1769 9.55385 10.3077 10.2769 9.58462C11 8.86154 11.8692 8.5 12.8846 8.5C13.9 8.5 14.7692 8.86154 15.4923 9.58462C16.2154 10.3077 16.5769 11.1769 16.5769 12.1923C16.5769 13.2077 16.2154 14.0769 15.4923 14.8C14.7692 15.5231 13.9 15.8846 12.8846 15.8846ZM22.1154 12.1923C22.1154 13.2077 21.7538 14.0769 21.0308 14.8C20.3077 15.5231 19.4385 15.8846 18.4231 15.8846C18.2538 15.8846 18.0385 15.8654 17.7769 15.8269C17.5154 15.7885 17.3 15.7462 17.1308 15.7C17.5462 15.2077 17.8654 14.6615 18.0885 14.0615C18.3115 13.4615 18.4231 12.8385 18.4231 12.1923C18.4231 11.5462 18.3115 10.9231 18.0885 10.3231C17.8654 9.72308 17.5462 9.17692 17.1308 8.68462C17.3462 8.60769 17.5615 8.55769 17.7769 8.53462C17.9923 8.51154 18.2077 8.5 18.4231 8.5C19.4385 8.5 20.3077 8.86154 21.0308 9.58462C21.7538 10.3077 22.1154 11.1769 22.1154 12.1923Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyicon);
export default __webpack_public_path__ + "static/media/companyicon.a3abd20269f79722b7c38770d1f9b8a4.svg";
export { ForwardRef as ReactComponent };